module.exports = __webpack_public_path__ + "img/2.82963db2.jpg";